import { Injectable } from '@angular/core';
import { ACCOUNT_STUB_ID } from '@epicuro-next/data/baskets-grouping';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as Sentry from '@sentry/angular';
import { filter, map, tap } from 'rxjs/operators';

import { loadBasketSuccess, loadDtoBasketSuccess } from '../actions';

@Injectable()
export class BasketSentryEffects {
  public groupedBasketWithoutDeliveryError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadBasketSuccess),
        map(({ basketData }) => {
          return {
            basketId: basketData.basketId,
            items: basketData.basketItems.filter(
              ({ accountId }) => accountId === ACCOUNT_STUB_ID,
            ),
          };
        }),
        filter(({ items }) => items.length > 0),
        tap(({ basketId, items }) => {
          const itemsError = items
            .map(({ basketItemId, productId, addressId, accountId }) => {
              return `id: ${basketItemId}, productId: ${productId}, addressId: ${addressId}, accountId: ${accountId}`;
            })
            .join('; ');
          return registerBasketItemWithoutDeliveryError(basketId, itemsError);
        }),
      ),
    {
      dispatch: false,
    },
  );

  public dtoBasketWithoutDeliveryError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadDtoBasketSuccess),
        map(({ basket }) => {
          return {
            items: basket.items.filter(
              (item) => !item.basketAccountId || !item.deliveryId,
            ),
            basketId: basket.basketId,
          };
        }),
        filter(({ items }) => items.length > 0),
        tap(({ basketId, items }) => {
          const itemsError = items
            .map(({ itemId, productId, deliveryId, basketAccountId }) => {
              return `id: ${itemId}, productId: ${productId}, deliveryId: ${deliveryId}, basketAccountId: ${basketAccountId}`;
            })
            .join('; ');
          return registerBasketItemWithoutDeliveryError(basketId, itemsError);
        }),
      ),
    {
      dispatch: false,
    },
  );

  constructor(private actions$: Actions) {}
}

export function registerBasketItemWithoutDeliveryError(
  basketId: string,
  itemsError: string = '',
) {
  const error = new Error(
    `No delivery in basket: ${basketId}. Items: ${itemsError}`,
  );
  Sentry.captureException(error);
}
